// extracted by mini-css-extract-plugin
export var textInput = "_ic-0";